import React from 'react';
import PropTypes from 'prop-types';
import LogViewer from './LogViewer';
import './PreviewRenderProgress.css';

/**
 * Phase label + thin progress bar + build log shown under the preview's
 * "Rendering …" spinner. Replaces three identical inline-styled copies that
 * lived in Canvas.jsx (dark #333 track, green gradient, black log box).
 */
const PreviewRenderProgress = ({ phase, progress = 0, logs }) => {
  if (!phase && !(logs && logs.length)) return null;
  const pct = Math.max(0, Math.min(100, progress || 0));

  return (
    <div className="render-progress">
      {phase && (
        <>
          <div className="render-progress-phase">
            <span className="render-progress-phase-name">{phase}</span>
            <span className="render-progress-phase-pct">{pct}%</span>
          </div>
          <div
            className="render-progress-track"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={pct}
          >
            <div className="render-progress-fill" style={{ width: `${pct}%` }} />
          </div>
        </>
      )}
      {logs && logs.length > 0 && <LogViewer logs={logs} variant="light" />}
    </div>
  );
};

PreviewRenderProgress.propTypes = {
  phase: PropTypes.string,
  progress: PropTypes.number,
  logs: PropTypes.array,
};

export default PreviewRenderProgress;
